import React from "react";

export const ContactMe = () => {
  return (
    <div className="footer p-5">
      <div className="container">
        <div className="text-center">
          <a className="btn  mx-4" href="mailto:firdausia1345@gmail.com">
            <i className="fa fa-envelope"></i>
          </a>
          <a className="btn  mx-4" href="https://github.com/4msha">
            <i className="fa fa-github"></i>
          </a>
          <a
            className="btn  mx-4"
            href="https://www.linkedin.com/in/firdausia-fatima-2007a11a8/"
          >
            <i className="fa fa-linkedin"></i>
          </a>
        </div>
      </div>
    </div>
  );
};
